import React from 'react';

import {
    Grid,
    Button,
    Divider,
    Collapse
} from '@mui/material';
import {
    CheckBox,
    CheckBoxOutlineBlank,
    ExpandMore,
    ExpandLess,
    Construction
} from '@mui/icons-material';

import { BoolField } from '@commonComponents/Form';
import { SectionDivider } from '@commonComponents';
import { TenantProfileType, METADATA_TYPES } from '@types';

interface EquipmentBlockProps {
    equipment: TenantProfileType['equipment'];
    onAllNone: ({ key, array }: { key: string; array: string[] }) => void;
    onClick: ({ key, value }: { key: string; value: string }) => void;
    settables: string[];
}

const Equipment: React.FC<EquipmentBlockProps> = (props) => {
    const {
        equipment = [],
        onAllNone,
        onClick,
        settables = []
    } = props;

    const [collapsed, setCollapsed] = React.useState<boolean>(false);
    const [selected, setSelected] = React.useState<'all' | 'some' | 'none'>('some');
    const key = METADATA_TYPES.EQUIPMENT;

    React.useEffect(() => {
        if (settables.every((veh) => equipment.includes(veh))) {
            setSelected('all');
        } else if (equipment.length === 0) {
            setSelected('none');
        } else {
            setSelected('some');
        }
    }, [equipment, settables]);

    const selectAll = () => {
        const newEquipment = Array.from(new Set([...equipment, ...settables]));
        onAllNone({ key, array: newEquipment });
    };

    const selectNone = () => {
        const newEquipment = equipment.filter((eq: string) => !settables.includes(eq));
        onAllNone({ key, array: newEquipment });
    };

    return (
        <Grid item xs={12} lg={6}>
            <SectionDivider
                label={(
                    <>
                        {`Utrustning (${equipment?.length || 0}) `}
                        {collapsed ? <ExpandMore /> : <ExpandLess />}
                    </>
                )}
                icon={<Construction fontSize="small" />}
                marginTop={0}
                marginBottom={2}
                onClick={() => setCollapsed(!collapsed)}
            />
            <Collapse in={!collapsed}>
                <Grid container spacing={1} sx={{ mb: 1 }}>
                    <Grid item>
                        <Button
                            size="small"
                            variant="text"
                            onClick={() => selectAll()}
                            startIcon={selected === 'all' ? <CheckBox /> : <CheckBoxOutlineBlank />}
                            sx={{ fontWeight: 300 }}
                        >
                            Alla
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            size="small"
                            variant="text"
                            onClick={() => selectNone()}
                            startIcon={selected === 'none' ? <CheckBox /> : <CheckBoxOutlineBlank />}
                            sx={{ fontWeight: 300 }}
                        >
                            Inga
                        </Button>
                    </Grid>
                </Grid>
                <Divider sx={{ mb: 2, width: '160px' }} />
                <Grid container spacing={1}>
                    {settables.map((eq) => (
                        <Grid item xs={12} sm={6} md={4} key={eq}>
                            <BoolField
                                name={eq}
                                label={eq}
                                value={equipment.includes(eq)}
                                onChange={() => onClick({ key, value: eq })}
                                sx={{ py: 0.25 }}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Collapse>
        </Grid>
    );
};

export default Equipment;
